export default __webpack_public_path__ + "static/media/aqua_floor.97f73a59.png";